import { z } from 'zod';

/** Admin login request (POST /api/v1/admin/auth/login). */
export const adminLoginInputSchema = z.object({
  username: z.string().trim().min(1).max(64),
  password: z.string().min(1).max(128),
});

export type AdminLoginInput = z.infer<typeof adminLoginInputSchema>;

/** Successful login response — a signed bearer token the SPA stores. */
export const adminSessionSchema = z.object({
  token: z.string().min(10),
  username: z.string(),
  expiresAt: z.string().datetime(),
});

export type AdminSession = z.infer<typeof adminSessionSchema>;
